import { useMutation } from "@tanstack/react-query";

import { apiClient } from "../../api/apiClient";
import { buildApiErrorMessage } from "../../utils/notification";

export type OcrSnipRequest = {
  case_number: string;
  file_name: string;
  page_number: number;
  x: number;
  y: number;
  width: number;
  height: number;
};

export type OcrSnipResponse = {
  status: "ready" | "processing";
  text?: string;
  source?: string;
  line_count?: number;
  message?: string;
};

export const useOcrSnip = () => {
  return useMutation({
    mutationFn: async (data: OcrSnipRequest): Promise<OcrSnipResponse> => {
      const response = await apiClient.post({
        url: "/api/v1/ocr-snip/extract",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.error) {
        throw new Error(
          buildApiErrorMessage("Failed to extract snip text", response.error)
        );
      }

      return response.data as OcrSnipResponse;
    },
  });
};
